<template>
  <div class="integral-centent">
    <div class="integral-top">
      <div class="img-explain">
        <p class="img">
          <img src="../../../../assets/apply/integral.png" alt />
        </p>
        <div class="explain">
          <p class="title">积分中心</p>
          <p class="price">免费</p>
          <p class="text">向客户进行积分奖励和兑换</p>
          <div class="switch">
            <el-switch
              v-model="switchValue"
              @change="changeStatus"
              active-color="#3D74F2"
              inactive-color="#EBEDF1"
            ></el-switch>
          </div>
        </div>
      </div>
      <div class="relevant" v-if="switchValue">
        <div class="title">相关信息</div>
        <p>
          <el-button class="btn-white" @click="toPointsAccount">积分账户</el-button>
          <el-button class="btn-white" @click="toIntegralSetting">积分设置</el-button>
        </p>
      </div>
    </div>
    <div class="integral-bottom">
      <div class="title">应用介绍</div>
      <div class="text">
        <p>开启积分兑换后，客户可在个人中心查看历史积分收支情况。您可以设置积分奖励规则，根据订单金额进行奖励，同时也可以根据商品设置单独</p>
        <p class="attention">注意：1. 订单金额积分奖励根据最后实际支付金额按比例奖励，当商品存在单独奖励规则时不参与订单金额积分奖励；</p>
        <p class="attention">2. 积分固定抵扣，1积分=0.1元，请谨慎设置积分奖励比例。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Apply from "models/db/apply";
const apply = new Apply();
export default {
  data() {
    return {
      switchValue: false,
    };
  },
  created() {
    this.$emit("childMueu", "积分中心");
    this.getDetailData();
  },
  methods: {
    // 获取当前页数据
    getDetailData() {
      apply.getPointsDetail().then((res) => {
        if (res.success) {
          this.switchValue = res.result.status === 1 ? true : false;
        }
      });
    },
    changeStatus() {
      let status = this.switchValue ? 1 : 0;;
      apply.postExpStatus().then((res) => {
        if (res.success) {
          if (status === 1) {
            this.$message.success("已开启");
          } else {
            this.$message.success("已关闭");
          }
        }
      });
    },
    toPointsAccount() {
      this.$router.push("/admin/apply/points-account");
    },
    toIntegralSetting() {
      this.$router.push("/admin/apply/integral-setting-list");
    }
  },
};
</script>
<style lang='scss' scoped>
.integral-centent {
  padding: 32px;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .integral-top {
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-bottom: 16px;
    box-sizing: border-box;
    padding: 16px;
    .img-explain {
      display: flex;
      margin-bottom: 20px;
      .img {
        width: 140px;
        height: 140px;
        box-shadow: 0px 0px 12px rgba($color: #233446, $alpha: 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
        img {
          width: 60px;
        }
      }
      .explain {
        margin-top: 10px;
        .title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 16px;
        }
        .price {
          color: #df3445;
          font-size: 16px;
          margin-bottom: 16px;
        }
        .text {
          color: #666666;
          font-size: 14px;
          margin-bottom: 16px;
        }
      }
    }
    .relevant {
      .title {
        padding-left: 16px;
        font-size: 16px;
        border-left: 4px solid #3d74f2;
        margin-bottom: 16px;
      }
      .number {
        padding-left: 20px;
        font-size: 14px;
      }
    }
  }
  .integral-bottom {
    flex: 1;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 16px;
    .title {
      padding-left: 16px;
      font-size: 16px;
      border-left: 4px solid #3d74f2;
      margin-bottom: 24px;
    }
    .text {
      display: flex;
      flex-direction: column;
      padding-top: 10px;
      align-items: center;
      p {
        width: 100%;
        text-align: left;
        font-size: 14px;
        color: #999999;
        margin-bottom: 14px;
      }
      .attention {
        color: #DF3445;
      }
      .attention:nth-last-child(1) {
        padding-left: 84px;
      }
    }
  }
}
</style>